import { render, staticRenderFns } from "./IconifyIcon.vue?vue&type=template&id=2dc8d0f4"
import script from "./IconifyIcon.vue?vue&type=script&lang=js"
export * from "./IconifyIcon.vue?vue&type=script&lang=js"
import style0 from "./IconifyIcon.vue?vue&type=style&index=0&id=2dc8d0f4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_webpack@5.99.8__handlebars@4.7.7_lodash@4.17.21_webpack@5.99.8/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports